import { render, staticRenderFns } from "./inforCard.vue?vue&type=template&id=0d943e58&"
import script from "./inforCard.vue?vue&type=script&lang=js&"
export * from "./inforCard.vue?vue&type=script&lang=js&"
import style0 from "./inforCard.vue?vue&type=style&index=0&id=0d943e58&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports